import { useNavigate } from 'react-router-dom'
import { Button } from './ui/button'
import { Badge } from './ui/badge'
import { Users, UserMinus } from 'lucide-react'
import KudosMenu from './KudosMenu'

export default function GroupMembersTab({
  members,
  canAccessSettings,
  currentUserId,
  removingMember,
  onRemoveMember,
  formatTimeAgo,
  groupId,
  canSendKudos = false,
  onKudosSent,
}) {
  const navigate = useNavigate()

  const getInitials = (name) => {
    if (!name) return '?'
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
  }

  if (members.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <Users className="h-12 w-12 mx-auto mb-4 opacity-50" />
        <p>No members yet</p>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      {members.map((member) => (
        <div key={member.user_id} className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between p-4 rounded-lg border bg-muted/30 hover:bg-muted/60 transition-colors">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center text-sm font-semibold">
              {getInitials(member.full_name)}
            </div>
            <div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => navigate(`/profile/${member.user_id}`)}
                  className="font-medium hover:underline hover:opacity-80 transition-opacity"
                >
                  {member.full_name || 'Unknown'}
                </button>
                {member.role === 'owner' && (
                  <Badge variant="secondary" className="text-xs">Owner</Badge>
                )}
              </div>
              <p className="text-xs text-muted-foreground">
                Joined {formatTimeAgo(member.joined_at)}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:justify-end">
            {canSendKudos && member.user_id !== currentUserId && (
              <KudosMenu
                groupId={groupId}
                recipientId={member.user_id}
                recipientName={member.full_name}
                onSent={onKudosSent}
              />
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate(`/profile/${member.user_id}`)}
            >
              View Profile
            </Button>
            {canAccessSettings && member.role !== 'owner' && member.user_id !== currentUserId && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onRemoveMember(member.user_id, member.full_name)}
                disabled={removingMember === member.user_id}
                className="text-destructive hover:text-destructive hover:bg-destructive/10"
              >
                {removingMember === member.user_id ? (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-destructive"></div>
                ) : (
                  <UserMinus className="h-4 w-4" />
                )}
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
